var map = {
	"./casinogames.json": [
		936,
		31
	],
	"./casinogames31.json": [
		937,
		32
	],
	"./casinogames33.json": [
		938,
		33
	],
	"./casinogames39.json": [
		939,
		34
	],
	"./casinogames47.json": [
		940,
		35
	],
	"./casinogames61.json": [
		941,
		36
	],
	"./instantgames.json": [
		942,
		37
	],
	"./instantgames31.json": [
		943,
		38
	],
	"./instantgames33.json": [
		944,
		39
	],
	"./instantgames39.json": [
		945,
		40
	],
	"./instantgames47.json": [
		946,
		41
	],
	"./instantgames61.json": [
		947,
		42
	],
	"./instantgamesBKP.json": [
		948,
		43
	],
	"./jsonBackUpFiles/casinogames-backup.json": [
		949,
		44
	],
	"./jsonBackUpFiles/slotgames-backup.json": [
		950,
		45
	],
	"./populargames.json": [
		951,
		46
	],
	"./populargames31.json": [
		952,
		47
	],
	"./populargames33.json": [
		953,
		48
	],
	"./populargames39.json": [
		954,
		49
	],
	"./populargames47.json": [
		955,
		50
	],
	"./populargames61.json": [
		956,
		51
	],
	"./slotgames.json": [
		957,
		52
	],
	"./slotgames31.json": [
		958,
		53
	],
	"./slotgames33.json": [
		959,
		54
	],
	"./slotgames39.json": [
		960,
		55
	],
	"./slotgames47.json": [
		961,
		56
	],
	"./slotgames61.json": [
		962,
		57
	],
	"./teenpatti.json": [
		360
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 820;
module.exports = webpackAsyncContext;